<template>
  <v-card id="promotion-list">
    <!-- search -->
    <v-card-text class="d-flex align-center flex-wrap pb-0">
      <div class="d-flex align-center pb-5">

        <v-btn
          color="primary"
          class="me-3"
          :disabled="hasNotPermission('Permissions.ContactCreate')"
          @click="createDialogShow()"
        >
          <v-icon
            size="18"
            class="me-1"
          >
            {{ icons.mdiPlus }}
          </v-icon>
          <span>Добавить</span>
        </v-btn>
      </div>

      <v-spacer></v-spacer>

      <div class="d-flex align-center pb-5">
        <v-text-field
          v-model="filters.searchQuery"
          single-line
          dense
          outlined
          hide-details
          placeholder="Поиск..."
          class="promotion-list-search me-3"
        ></v-text-field>
      </div>
    </v-card-text>

    <!-- table -->
    <v-data-table
      :headers="headers"
      :items="contacts"
      :server-items-length="totalCount"
      :loading="loading"
      :page.sync="filters.pageNumber"
      :items-per-page.sync="filters.pageSize"
      :sort-by.sync="filters.sortBy"
      :sort-desc.sync="filters.sortDesc"
      class="text-no-wrap"
    >

      <!-- name -->
      <template #[`item.name`]="{item}">
        {{ item.name }}
      </template>


      <template #[`item.type`]="{item}">
        <v-icon
          size="20"
          class="rounded-0"
        >
          {{ getIcon(item.type) }}
        </v-icon>
      </template>


      <template #[`item.contact`]="{item}">
        <span class="ma-0 pa-0">{{ item.contact }}</span>
      </template>

      <!-- actions -->
      <template #[`item.actions`]="{item}">
        <div class="d-flex align-center justify-center">

          <!-- edit -->
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                icon
                small
                :disabled="hasNotPermission('Permissions.ContactUpdate')"
                v-bind="attrs"
                v-on="on"
                @click="updateDialogShow(item.id)"
              >
                <v-icon size="18">
                  {{ icons.mdiPencilOutline }}
                </v-icon>
              </v-btn>
            </template>
            <span>Редактирование</span>
          </v-tooltip>

          <!-- delete -->
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                icon
                small
                v-bind="attrs"
                :disabled="hasNotPermission('Permissions.ContactDelete')"
                v-on="on"
                @click="deletePopupShow(item.id, item.name)"
              >
                <v-icon size="18">
                  {{ icons.mdiDeleteOutline }}
                </v-icon>
              </v-btn>
            </template>
            <span>Удалить</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
    <delete-dialog @delete-confirmed="deleteContact" :label="deleteLabel" ref="deletePopup" />
    <contact-form :label="'Редактирование контката'" :cancellation="updateDialogCancel" :show="updateDialog"
                  :save="updateContact"></contact-form>
    <contact-form :label="'Создание контакта'" :cancellation="createDialogCancel" :show="createDialog"
                  :save="addContact"></contact-form>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { mapFormHandlers } from '@/helpers/forms'
import DeleteDialog from '@/components/delete-dialog'
import ContactForm from './contact-form'
import {
  mdiTrendingUp,
  mdiPlus,
  mdiDeleteOutline,
  mdiDotsVertical,
  mdiOdnoklassniki,
  mdiVk,
  mdiEyeOutline,
  mdiFacebook,
  mdiGooglePlay,
  mdiEmail,
  mdiApple,
  mdiInstagram,
  mdiWhatsapp,
  mdiPhone,
  mdiPencilOutline,
} from '@mdi/js'
import { toDateSting, hasPermission } from '@/helpers/index'

export default {
  components: { DeleteDialog, ContactForm },
  name: 'ContactList',
  data: () => ({
    createDialog: false,
    updateDialog: false,
    icons: {
      mdiTrendingUp,
      mdiPlus,
      mdiOdnoklassniki,
      mdiVk,
      mdiPencilOutline,
      mdiDeleteOutline,
      mdiDotsVertical,
      mdiGooglePlay,
      mdiApple,
      mdiEmail,
      mdiEyeOutline,
      mdiFacebook,
      mdiInstagram,
      mdiWhatsapp,
      mdiPhone,
    },
    deleteLabel: '',
    deleteMethod: null,
  }),
  computed: {
    ...mapFormHandlers('contact', [
      'filters.pageNumber',
      'filters.pageSize',
      'filters.searchQuery',
      'filters.sortBy',
      'filters.sortDesc',
    ]),
    ...mapState('contact', {
      contacts: 'list',
      totalCount: 'totalCount',
      loading: 'loading',
    }),
    headers() {
      return [
        { text: 'Наименование', value: 'name' },
        { text: 'Тип', value: 'type' },
        { text: 'Контакт', value: 'contact', width: '200px', class: "mr-4" },
        {
          text: 'Действия',
          value: 'actions',
          align: 'center',
          sortable: false,
        },
      ]
    },
  },
  async created() {
    document.title = 'Контакты'
    this.fetchContacts()
  },
  methods: {
    ...mapActions('contact', {
      fetchContacts: 'fetchList',
      deleteContact: 'delete',
    }),
    ...mapActions('contact/form', ['create', 'resetForm', 'fetchById', 'update']),
    hasNotPermission(val){
      return !hasPermission(val);
    },
    deletePopupShow(id, name) {
      this.deleteLabel = 'Контакт ' + name + ' будет удален.'
      this.$refs.deletePopup.open(id)
    },
    async addContact() {
      await this.create()
      this.createDialog = false
    },
    async updateContact() {
      await this.update()
      this.updateDialog = false
    },
    toDate(val) {
      return toDateSting(val)
    },
    createDialogShow() {
      this.createDialog = true
    },
    getIcon(val) {
      switch (val) {
        case 'Instagram':
          return this.icons.mdiInstagram
        case 'Facebook':
          return this.icons.mdiFacebook
        case 'PhoneNumber':
          return this.icons.mdiPhone
        case 'WhatsApp':
          return this.icons.mdiWhatsapp
        case 'GooglePlay':
          return this.icons.mdiGooglePlay
        case 'AppStore':
          return this.icons.mdiApple
        case 'Email':
          return this.icons.mdiEmail
        case 'OK':
          return this.icons.mdiOdnoklassniki
        case 'VK':
          return this.icons.mdiVk
      }

    },
    createDialogCancel() {
      this.createDialog = false
    },
    updateDialogCancel() {
      this.updateDialog = false
    },
    updateDialogShow(id) {
      this.fetchById(id)
      this.updateDialog = true
    },
  },
}
</script>

<style lang="scss" scoped>
#promotion-list {
  .promotion-list-search {
    max-width: 10.625rem;
  }
}
</style>
